import * as React from 'react';

const SvgEllipses = props => (
  <svg
    data-name="Component 8 \u2013 1"
    height={107}
    viewBox="0 0 104 107"
    width={104}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      data-name="Ellipse 12"
      fill="none"
      stroke="#00572c"
      transform="translate(1 2)"
    >
      <circle
        cx={51}
        cy={51}
        r={51}
        stroke="none"
      />
      <circle
        cx={51}
        cy={51}
        r={50.5}
      />
    </g>
    <g
      data-name="Ellipse 13"
      fill="none"
      stroke="#007d30"
      transform="translate(0 3)"
    >
      <circle
        cx={52}
        cy={52}
        r={52}
        stroke="none"
      />
      <circle
        cx={52}
        cy={52}
        r={51.5}
      />
    </g>
    <g
      data-name="Ellipse 14"
      fill="none"
      stroke="#559303"
    >
      <circle
        cx={51}
        cy={51}
        r={51}
        stroke="none"
      />
      <circle
        cx={51}
        cy={51}
        r={50.5}
      />
    </g>
  </svg>
);

export default SvgEllipses;

